export enum CustomerRegistrationCountries {
  CZ = 'CZ',
  SK = 'SK',
  NL = 'NL',
  DE = 'DE',
  FR = 'FR',
  GB = 'GB',
  BE = 'BE',
}
